import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CenterPanel from './centerPanel';
import { getHomePanelMeetingRooms } from '../../../../actions/meetingRoom';

export default function MeetingRoomRecentCalls(props) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.fetching != true) {
      dispatch(getHomePanelMeetingRooms(null, true));
    }
  }, []);

  const maxRecordsToDisplay = 5;
  const totalMeetingRooms = props.totalMeetingRooms;
  const recordCurrentlyDisplayed = totalMeetingRooms > maxRecordsToDisplay ? maxRecordsToDisplay : totalMeetingRooms;
  const records = props.meetingRooms;
  return (
    <div>
      <div className="meeting-room-recent-calls">
        <CenterPanel
          noHeader={props.noHeader}
          fetching={props.fetching}
          quickViewMeetingRooms={records}
          isInCall={props.isInCall}
        />
      </div>

      <div className="center-text">
        <span
          data-show={props.meetingRooms.length > 0}
          className="hand  text-size-ms "
          onClick={props.goToMeetingRooms}
        >
          {APP.LANGUAGE.QuickViewMeetingRoom.TitleDisplaying} <span className="bold">{recordCurrentlyDisplayed}</span>{' '}
          {APP.LANGUAGE.QuickViewMeetingRoom.TitleDisplayingOf} <span className="bold">{totalMeetingRooms}</span>{' '}
          {APP.LANGUAGE.Menu.MeetingRooms}
        </span>
      </div>
    </div>
  );
}
